import NumberFacet from './NumberFacetPresentation';
import NumberFacetUtils from './NumberFacetUtils';
import { FacetLogic, RenderFacetProps } from './Types';

function renderFacet (props: RenderFacetProps) { 
    return <NumberFacet 
              key={props.field.name} 
              name={props.field.name} 
              displayName={props.field.userSettings.displayName} 
              facetValues={props.facetValues} 
              facetSelection={props.facetSelection}
              onChangeFacet={props.onChangeFacetSelection}/>          
}

export const createFacetLogic = (dataType: string): FacetLogic => ({
    dataType: dataType,
    createFilter: NumberFacetUtils.createFilter,
    createRequest: NumberFacetUtils.createRequest,
    extractFacetValues: NumberFacetUtils.extractFacetValues,
    renderFacet: renderFacet,
    createUpdatedSelection: NumberFacetUtils.createUpdatedSelection,
});

// Usage
export const int32FacetLogic = createFacetLogic('Edm.Int32');
export const int64FacetLogic = createFacetLogic('Edm.Int64');
export const doubleFacetLogic = createFacetLogic('Edm.Double');